<div
  class="text-center loading"
  role="status"
  [attr.aria-label]="'Loading content'"
  [attr.aria-live]="'polite'"
>
  <div
    class="spinner"
    role="presentation"
    aria-hidden="true"
  >
    <div class="double-bounce1"></div>
    <div class="double-bounce2"></div>
  </div>
  <span class="visually-hidden">Loading, please wait...</span>
</div>
